module.exports = {
      id: "icon-audio-app-store-usage",
      viewBox: "0 0 122 41",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-audio-app-store",
      toString: function () {
        return this.url;
      }
    }